import { apiFetch } from "@/shared/api/apiFetch";
import { readApiErrorMessage } from "@/shared/api/parseApiErrorMessage";
import type {
  LearningHistoryAlternative,
  LearningHistoryResolution,
} from "@/features/chat/model/chatTypes";

/**
 * Records, on the answer's turn, that the user changed a meaning applied from their Learning
 * History. It is stored in the chat (not in Learning History): the rest of the chat uses the new
 * choice straight away, and Learning History learns from it on its next nightly run.
 */
export async function recordConceptChoice(
  turnId: string,
  resolution: LearningHistoryResolution,
  alternative: LearningHistoryAlternative,
): Promise<void> {
  const res = await apiFetch(`/v1/chat/turns/${turnId}/concept-choice`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      term: resolution.term,
      rejected_owner_type: resolution.ownerType,
      rejected_owner_key: resolution.ownerKey,
      chosen_owner_type: alternative.ownerType,
      chosen_owner_key: alternative.ownerKey,
      chosen_label: alternative.label,
    }),
  });
  if (!res.ok) {
    throw new Error(await readApiErrorMessage(res));
  }
}
